import React from "react";
import RotateRightIcon from "@mui/icons-material/RotateRight";

type LoadingArrowOverlayProps = {
  loading: boolean;
};

const LoadingArrowOverlay: React.FC<LoadingArrowOverlayProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="absolute inset-0 z-1000 flex items-center justify-center bg-white/60 pointer-events-none">
      <RotateRightIcon
        fontSize="large"
        sx={{
          "animation": "mui-spin 0.9s linear infinite",
          "@keyframes mui-spin": { to: { transform: "rotate(360deg)" } },
        }}
      />
    </div>
  );
};

export default LoadingArrowOverlay;
